import * as React from "react";

const Logo = (props) => (
  <img
    src="https://d337qwjyep6w7b.cloudfront.net/assets/IL_logo.png"
    height={180}
  />
);

export default Logo;
